"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsersBackofficeClientImpl = void 0;
const http_status_1 = __importDefault(require("http-status"));
const sfp_types_1 = require("@jetseafoodas/sfp-types");
const HttpClientImpl_1 = require("./HttpClientImpl");
class UsersBackofficeClientImpl extends HttpClientImpl_1.HttpClientImpl {
    constructor(options, prefix) {
        super(options);
        this.list = async (request) => {
            return this.post(`${this.prefix}/`, request);
        };
        this.create = async (request) => {
            return this.put(`${this.prefix}`, request);
        };
        this.fetch = async (userId) => {
            return this.get(`${this.prefix}/${userId}`);
        };
        this.fetchByEmail = async (email) => {
            return this.get(`${this.prefix}/${email}/email`);
        };
        this.update = async (userId, request) => {
            return this.put(`${this.prefix}/${userId}`, request);
        };
        this.enableUser = async (userId) => {
            return this.post(`${this.prefix}/${userId}/enable`);
        };
        this.disableUser = async (userId) => {
            return this.post(`${this.prefix}/${userId}/disable`);
        };
        this.fetchRequestLogs = async (request) => {
            if (!request.userId) {
                throw new sfp_types_1.APIError({ message: `UserId is required`, status: http_status_1.default.BAD_REQUEST });
            }
            return this.post(`${this.prefix}/${request.userId}/requestlogs`, request);
        };
        this.prefix = `${prefix}/v1/user/backoffice`;
    }
}
exports.UsersBackofficeClientImpl = UsersBackofficeClientImpl;
